import React from 'react'
import { shape, string, bool, func } from 'prop-types'
import { getIn } from 'formik'
import DiscountInput from '~/components/common/DiscountInput'

const FormDiscountInput = ({
  onSelect,
  form,
  field,
  error,
  clearable,
  helperText,
  inputProps,
  onChange,
  disabled,
  ...props
}) => (
  <DiscountInput
    error={
      !!error ||
      (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
    }
    helperText={
      helperText ||
      (getIn(form.touched, field.name) &&
        getIn(form.errors, field.name)?.discountAmount)
    }
    inputProps={{
      name: `${field?.name}.discountAmount`,
      ...inputProps,
    }}
    type={field?.value?.discountType}
    onChange={(e) => {
      if (onChange) {
        onChange(e.target.value ? Number(e.target.value) : e.target.value)
      } else {
        form.setFieldValue(
          `${field?.name}.discountAmount`,
          e.target.value ? Number(e.target.value) : e.target.value,
        )
      }
    }}
    value={field?.value?.discountAmount}
    onSelect={(val) => {
      if (onSelect) {
        onSelect(val)
      } else {
        form.setFieldValue(`${field?.name}.discountType`, val)
      }
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

FormDiscountInput.defaultProps = {
  inputProps: {},
  clearable: false,
  error: '',
  helperText: '',
  onSelect: null,
  onChange: null,
  disabled: false,
}

FormDiscountInput.propTypes = {
  onSelect: func,
  onChange: func,
  form: shape().isRequired,
  inputProps: shape(),
  field: shape().isRequired,
  clearable: bool,
  error: string,
  helperText: string,
  disabled: bool,
}

export default FormDiscountInput
